import { render, staticRenderFns } from "./AConceptospago.vue?vue&type=template&id=42cd94a1"
import script from "./AConceptospago.vue?vue&type=script&lang=js"
export * from "./AConceptospago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports